import z from 'zod'

export const CreatePaymentSessionSchema = z.object({
    cart_id: z.string().min(1),
})
